import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from 'src/app/shared/services';
import { adminMenu, employeeMenu, managerMenu } from 'src/environments/variables';

interface MenuItem {
  label:string;
  icon?:string;
  route:string;
}

@Component({
    imports: [CommonModule, RouterModule],
    selector: 'app-dashboard-sidebar',
    templateUrl: './dashboard-sidebar.component.html',
})
export class DashboardSidebarComponent implements OnInit {
  @Output() onOptionSelected = new EventEmitter<boolean>();

  private authService = inject(AuthService)

  public user = computed(() => this.authService.currentUser());

  public homeItems:MenuItem[];

  ngOnInit(): void {

    switch (this.user()?.role) {
      case 'super':
        this.homeItems = adminMenu;
        break;
      case 'admin':
        this.homeItems = adminMenu;
        break;
      case 'manager':
        this.homeItems = managerMenu;
        break;

      case 'user' : 
      this.homeItems = employeeMenu;
        break;
    }

  }

  selectOption() {
    this.onOptionSelected.emit(true);
  }

}
